import { IContact } from 'clickNgo/entities/contact'
import { onboardingContactApi } from 'onboarding/classes/services/api/OnboardingContactApi'

import { IUpdateContactIdProps } from '../classes/models/onboardingContactModels'

class ContactService {
  public fetchByContactId(contactId: string, cacheKey?: string) {
    return onboardingContactApi.fetchByContactId(contactId, cacheKey)
  }

  public getExistingContactsByPartnerId(partnerId: string, accessToken: string) {
    return onboardingContactApi.getExistingContactsByPartnerId(partnerId, accessToken)
  }

  public checkExistenceByEmail(partnerId: string, email: string) {
    return onboardingContactApi.checkExistenceByEmail(partnerId, email)
  }

  public getContactsWithMultiplePartners(requestId: number) {
    return onboardingContactApi.getContactsWithMultiplePartners(requestId)
  }

  public validateContact(contact: Partial<IContact>) {
    return onboardingContactApi.validateContact(contact)
  }

  public updateContactId(data: IUpdateContactIdProps) {
    return onboardingContactApi.updateContactId(data)
  }

  public generateNewContactId() {
    return onboardingContactApi.generateNewContactId()
  }
}

export const contactService = new ContactService()
